import {TabState, TabStateDefaults} from 'Navigation';
import WorksheetFileState from 'notebook/worksheets/workspace/WorksheetFileState';

export default class WorksheetTabState extends TabState {
  defaults(): TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Steps',
      closeable: false,
      preferenceKey: 'worksheet',
    };
  }

  getWorksheetFileState(): WorksheetFileState {
    return this.get('worksheetFileState');
  }
}
